module.exports = __webpack_public_path__ + "static/media/top-rated-guide-2025.822f41d9.png";